import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-fix-milkings-alerts-options',
	templateUrl: './fix-milkings-alerts-options.component.html',
	styleUrls: ['./fix-milkings-alerts-options.component.scss'],
})
export class FixMilkingsAlertsOptionsComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<FixMilkingsAlertsOptionsComponent>
	) {}

	ngOnInit(): void {}

	closeDialog(mode: 'all' | 'filters' | null): void {
		this.dialogRef.close(mode);
	}
}
